/**
 * Created by admin on 2017/5/24.
 */
const CryptoJS = require('crypto-js')

const key = CryptoJS.enc.Utf8.parse('qwertyuiopasdfghjkl1234567890zxcvbnm')
const iv = CryptoJS.enc.Utf8.parse('zxcvbnmasdfghjkl1234567890qwertyuio')

// create custom json serialization format
const JsonFormatter = {
  stringify: function (cipherParams) {
    // create json object with ciphertext
    const jsonObj = {
      ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)
    }

    // optionally add iv and salt
    if (cipherParams.iv) {
      jsonObj.iv = cipherParams.iv.toString()
    }

    if (cipherParams.salt) {
      jsonObj.s = cipherParams.salt.toString()
    }

    // stringify json object
    return JSON.stringify(jsonObj)
  },

  parse: function (jsonStr) {
    // parse json string
    const jsonObj = JSON.parse(jsonStr)

    // extract ciphertext from json object, and create cipher params object
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(jsonObj.ct)
    })

    // optionally extract iv and salt
    if (jsonObj.iv) {
      cipherParams.iv = CryptoJS.enc.Hex.parse(jsonObj.iv)
    }

    if (jsonObj.s) {
      cipherParams.salt = CryptoJS.enc.Hex.parse(jsonObj.s)
    }
    return cipherParams
  }
}

export function encode (content) {
  try {
    const options = {iv: iv, asBytes: true, format: JsonFormatter}
    const crypted = CryptoJS.AES.encrypt(content, key, options)
    return crypted.toString()
  } catch (e) {
    return content
  }
}

export function decode (text) {
  try {
    const data = JSON.parse(text)
    const decryptIv = CryptoJS.enc.Hex.parse(data.iv)
    const options = {iv: decryptIv, asBytes: true, format: JsonFormatter}
    const decrypted = CryptoJS.AES.decrypt(text.toString(), key, options)
    // convert to Utf8 format unmasked data
    return CryptoJS.enc.Utf8.stringify(decrypted)
  } catch (e) {
    return text
  }
}



// WEBPACK FOOTER //
// ./src/utils/encryption.js